import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSubscriberAdvertiserComponent } from '../../abstract-components/base-subscriber-advertiser.component';

@Component({
  selector: 'subscriber-advertiser-card',
  standalone: false,
  templateUrl: './subscriber-advertiser-card.component.html',
  styleUrl: './subscriber-advertiser-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdvertiserCardComponent extends BaseSubscriberAdvertiserComponent {}
